import React from 'react';
import SEOHeadNative from '../components/SEOHeadNative';

const sectionStyle: React.CSSProperties = {
  marginBottom: '30px',
};

const articleTitleStyle: React.CSSProperties = {
  color: 'var(--ozarks-blue-dark)',
  fontSize: '18px',
  fontWeight: 700,
  marginBottom: '12px',
  marginTop: '0',
};

const paragraphStyle: React.CSSProperties = {
  color: '#444',
  fontSize: '15px',
  lineHeight: '1.75',
  marginBottom: '10px',
};

const CGV: React.FC = () => {
  const pdfPath = '/documents/CGV.pdf';

  return (
    <div>
      <SEOHeadNative
        title="Conditions Générales de Vente (CGV) - OZARKSELEC"
        description="Consultez les conditions générales de vente d'OZARKSELEC. Téléchargez ou consultez le document PDF des CGV."
        keywords="CGV, conditions générales de vente, OZARKSELEC, contrat, devis"
        canonical="/cgv"
      />

      <div className="r t-rec t-rec_pt_90 t-rec_pb_90" style={{ paddingTop: '90px', paddingBottom: '90px' }}>
        <div className="t-container">
          <div className="t-col t-col_10 t-prefix_1">
            <div className="t-align_center">
              <h1 className="t-title t-title_xs ozarks-blue-dark" style={{ marginBottom: '20px' }}>
                Conditions Générales de <span className="ozarks-blue-medium">Vente</span>
              </h1>
              <div className="t-descr t-descr_xl t-margin_auto" style={{ marginBottom: '30px', color: 'var(--ozarks-gray)', maxWidth: '600px' }}>
                Consultez nos conditions générales de vente ci-dessous ou téléchargez le document PDF
              </div>
              <a
                href={pdfPath}
                download
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  backgroundColor: 'var(--ozarks-blue-dark)',
                  color: 'white',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: 500,
                  fontSize: '15px',
                  transition: 'all 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--ozarks-blue-medium)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--ozarks-blue-dark)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                </svg>
                Télécharger le PDF
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="r t-rec t-rec_pt_0 t-rec_pb_90" style={{ paddingTop: '0', paddingBottom: '90px' }}>
        <div className="t-container">
          <div className="t-col t-col_10 t-prefix_1">
            <div style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              boxShadow: '0 4px 20px var(--ozarks-shadow)',
              padding: '40px',
              maxWidth: '800px',
              margin: '0 auto',
            }}>

              {/* Article 1 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 1 : CHAMP D'APPLICATION</h2>
                <p style={paragraphStyle}>
                  Les conditions générales de vente s'appliquent à toutes les ventes ou prestations de services signées par l'entreprise Ozarkselec et son client, sauf conditions particulières mentionnées sur le devis. La signature du devis implique la connaissance et l'adhésion pleine et entière à ces CGV ci-dessous qui prévalent sur tout document de l'acheteur, sous réserves des conditions spécifiques qui lui auront été communiquées sur le devis, ou qui résulteraient d'une négociation ultérieure approuvée par les deux parties faisant l'objet d'un devis avenant.
                </p>
              </div>

              {/* Article 2 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 2 : COMMANDES ET DEVIS</h2>
                <p style={paragraphStyle}>
                  Les devis sont valables 1 mois à compter de la date d'émission. L'entreprise Ozarkselec se garde le droit de modifier les prix après ce délai.
                </p>
                <p style={paragraphStyle}>
                  La commande n'est validée qu'après signature et envoi, par le client, du devis accompagné d'un chèque ou virement d'acompte, correspondant à 40% TTC de son montant, sauf mentions contraires sur le devis, et confirmée par l'entreprise Ozarkselec. Le délai légal de rétraction est de 14 jours à compter de la signature du devis (article L. 221-18 du code de la consommation), en cas d'annulation par le client passé ce délai, l'acompte versé sera acquis de plein droit par l'entreprise Ozarkselec. La date d'intervention mentionnée sur le devis est indiquée à titre indicatif et ne peut être pris au pied de la lettre, la date d'intervention ou de début de chantier ne seras communiqué au client qu'après réception du devis signé et du versement de l'acompte.
                </p>
                <p style={paragraphStyle}>
                  Concernant les modifications ou annulation du chantier, l'entreprise Ozarkselec doit être informée de façon manuscrite.
                </p>
                <p style={paragraphStyle}>
                  Dans le cas où le Client passe une commande à l'entreprise Ozarkselec sans avoir procédé à ses obligations des précédentes commandes, ou dans le cas où la situation du Client venait à évoluer, ou en cas de litige passé ou présent, l'entreprise Ozarkselec se réserve le droit de refuser d'accepter ou d'honorer une commande, sans que le Client puisse prétendre à une quelconque indemnité, pour quelque raison que ce soit.
                </p>
                <p style={paragraphStyle}>
                  Pour les mairies et collectivités publiques, il sera demandé un bon de commande ou ordre de service cacheté et signé du Maire ou de son représentant. Le paiement s'effectue par virement bancaire à réception de la facture (RIB joint au devis).
                </p>
              </div>

              {/* Article 3 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 3 : PRIX</h2>
                <p style={paragraphStyle}>
                  Le prix des marchandises correspond aux prix en vigueur le jour de la prise de commande.
                </p>
                <p style={paragraphStyle}>
                  Les prix et conditions particulières figurant sur les catalogues, plaquettes, site web et tous supports commerciaux, ainsi que ceux indiqués oralement par l'entreprise Ozarkselec au Client sont seulement indicatifs et ne constituent pas des offres, quel que soit leur mode de communication. Seuls les devis signés unilatéralement sont opposables.
                </p>
                <p style={paragraphStyle}>
                  Ils sont libellés en euros. Tout changement de taux sera répercuté sur le prix. Les suppléments feront l'objet d'un devis complémentaire, qui devra être signé.
                </p>
                <p style={paragraphStyle}>
                  Le règlement s'effectue par chèque, par virement bancaire ou en cash. Le solde, après déduction des acomptes, devra être payé à réception de la facture, toutefois un délais raisonnable de 30 jours suivant la signature de la réception de chantier, ou à défaut à la date d'envoi de la facture est laissé au Client. En cas de paiement par chèque bancaire, celui-ci doit être émis par une banque domiciliée en France métropolitaine, la mise à l'encaissement du chèque est réalisée à la réception de celui-ci.
                </p>
                <p style={paragraphStyle}>
                  Aucun escompte ne sera accordé en cas de paiement anticipé.
                </p>
                <p style={paragraphStyle}>
                  Toute somme non payée à l'échéance entraîne l'application d'une pénalité de 12,5% reconductible tous les 30 jours de retard, calculée au prorata temporis sur les sommes dues (art. L4416 du code du commerce), ainsi qu'une indemnité forfaitaire de recouvrement de 40€ (art. L4416 et art. D4415 du code du commerce). Cette pénalité est calculée sur la somme restant due sans qu'aucune mise en demeure préalable ne soit nécessaire. Elle sera effective dans un délai de 30 jours après la signature de la réception de chantier, ou à défaut, après la date d'envoi de la facture.
                </p>
                <p style={paragraphStyle}>
                  Ozarkselec s'aidera d'un huissier à la charge du débiteur afin de régulariser la facture dû.
                </p>
              </div>

              {/* Article 4 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 4 : RESPONSABILITÉ LIÉE AUX INFORMATIONS FOURNIES ET AUX CONTRAINTES EXTÉRIEURES</h2>
                <p style={paragraphStyle}>
                  Les travaux sont réalisés sur la base des informations, documents, plans, photographies et indications fournis par le client ou ses représentants (maître d'œuvre, architecte, organisme tiers, etc…). Ozarkselec ne pourra être tenue responsable des erreurs, omissions, imprécisions ou défauts de ces éléments, ni des conséquences techniques ou financières qui en résulteraient. Il appartient au client de s'assurer de l'exactitude, de la complétude et de la conformité des informations transmises, notamment au regard des exigences des organismes tiers (gestionnaire de réseau, organisme de contrôle, administration, etc…).
                </p>
                <p style={paragraphStyle}>
                  Toute évolution du chantier, contrainte technique non visible lors de l'établissement du devis, ou demande complémentaire intervenant en cours ou après réalisation des travaux, notamment à la suite d'une intervention ou prescription d'un tiers, donnera lieu à l'établissement d'un devis complémentaire et à une facturation supplémentaire. Les prestations initialement prévues et réalisées conformément au devis signé restent intégralement dues, indépendamment de toute modification ultérieure ou demande complémentaire.
                </p>
                <p style={paragraphStyle}>
                  Sauf mention contraire expresse, l'entreprise est tenue à une obligation de moyens et non de résultat concernant les exigences d'organismes tiers.
                </p>
              </div>

              {/* Article 5 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 5 : MAJORATION</h2>
                <p style={paragraphStyle}>La main d'œuvre est majorée de :</p>
                <ul style={{ ...paragraphStyle, paddingLeft: '25px', marginTop: '5px' }}>
                  <li style={{ marginBottom: '6px' }}>50% de 00h à 8h et de 18h à 24h du lundi au samedi</li>
                  <li>100% le dimanche et jours fériés</li>
                </ul>
              </div>

              {/* Article 6 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 6 : DÉPLACEMENT</h2>
                <p style={paragraphStyle}>
                  Les frais de déplacement sont calculés en référence de l'arrêté du 27 mars 2023 fixant le barème forfaitaire des frais de déplacement (article 6 B de l'annexe IV au CGI), ceux-ci sont proportionnel à la sommes des kilométrages parcouru pour mener à bien la réalisation du devis.
                </p>
              </div>

              {/* Article 7 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 7 : SOUS-TRAITANCE</h2>
                <p style={paragraphStyle}>
                  L'entreprise Ozarkselec se réserve la possibilité de sous-traiter ou d'effectuer de la sous-traitance pour une partie ou la totalité du chantier, à n'importe quelle étape d'avancement de ce dernier.
                </p>
              </div>

              {/* Article 8 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 8 : RÉSERVE DE PROPRIÉTÉ</h2>
                <p style={paragraphStyle}>
                  L'ensemble des marchandises restent la possession de l'entreprise Ozarkselec jusqu'au paiement intégral de leur prix, l'acheteur en deviendra responsable dès leur remise matérielle, le transfert de possession entraînant celui des risques. En outre si le client fait l'objet d'un redressement ou d'une liquidation judiciaire, l'entreprise Ozarkselec se réserve le droit de revendiquer les marchandises vendues et restées impayées.
                </p>
                <p style={paragraphStyle}>
                  L'acheteur s'engage à souscrire dès l'acceptation du présent document, un contrat d'assurance garantissant les risques de perte, vol ou destruction des marchandises et fournitures désignées.
                </p>
              </div>

              {/* Article 9 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 9 : LIVRAISON ET DÉLAIS</h2>
                <p style={paragraphStyle}>
                  Les délais de livraison sont donnés à titre informatif et indicatif, et ne sont pas de rigueur. En conséquence, tout retard raisonnable (- de 30 jours) dans la livraison des marchandises et/ou prestations de services ne pourra pas donner lieu au profit du client de dommage et intérêt et/ou à l'annulation de la commande.
                </p>
              </div>

              {/* Article 10 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 10 : COORDINATION AVEC LES AUTRES CORPS DE MÉTIER, ENTREPRISE ET DÉLAI D'INTERVENTION</h2>
                <p style={paragraphStyle}>
                  Lorsque l'exécution des prestations d'Ozarkselec dépend de l'avancement d'autres corps de métier ou entreprise, le client s'engage à informer Ozarkselec de la date à laquelle les locaux seront accessibles pour la réalisation des travaux, au minimum 15 jours avant la date souhaitée d'intervention.
                </p>
                <p style={paragraphStyle}>
                  À réception de cette information, Ozarkselec planifie son intervention en fonction de son planning en cours, sans qu'un délai imposé par un autre intervenant ou par le client ne puisse modifier l'organisation interne de l'entreprise.
                </p>
                <p style={paragraphStyle}>
                  En conséquence les délais d'intervention restent indicatifs et non contractuels, aucun tiers ne peut se substituer à l'entreprise pour réaliser tout ou partie des travaux prévus au devis sans accord écrit préalable d'Ozarkselec.
                </p>
                <p style={paragraphStyle}>
                  Toute prestation prévue au devis dûment signé reste exigible, y compris la main-d'œuvre et le matériel déjà commandé ou fourni, même en cas de réalisation partielle ou totale par un tiers non autorisé, aucun décompte, réduction ou retenue sur facturation ne pourra être exigé du fait du retard d'un autre corps de métier ou de la volonté du client de remplacer Ozarkselec par un tiers. Les retards d'autres intervenants ne sauraient, en aucun cas, être imputés à Ozarkselec ni constituer un motif d'annulation totale ou partielle de la commande.
                </p>
              </div>

              {/* Article 11 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 11 : FORCE MAJEURE</h2>
                <p style={paragraphStyle}>
                  La responsabilité de l'entreprise Ozarkselec ne pourra pas être mise en œuvre si la non-exécution ou le retard de l'exécution de l'une des obligations décrites dans les présentes conditions générales de vente découle d'un cas de force majeure.
                </p>
                <p style={paragraphStyle}>
                  L'entreprise Ozarkselec n'est pas responsable notamment en cas d'incendies, inondations, interruption de la fourniture d'énergie, de matière première ou pièces détachées, ainsi que les grèves totales ou partielles de toute nature entravant la bonne marche de l'entreprise telle que les grèves des transports ou des services postaux. La survenance d'un cas de force majeure a pour effet de suspendre l'exécution des obligations contractuelles de l'entreprise.
                </p>
                <p style={paragraphStyle}>
                  D'autre part, l'entreprise se réserve le droit de ne pas intervenir ou de reporter sa prestation si les présentes conditions ne sont pas respectées ou en cas d'encombrement ou insalubrité des lieux d'intervention. Le déplacement reste dû.
                </p>
              </div>

              {/* Article 12 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 12 : RESPONSABILITÉ</h2>
                <p style={paragraphStyle}>
                  L'entreprise Ozarkselec déclare être assurée pour sa Responsabilité Civile Professionnelle auprès d'une Compagnie d'assurance MAAF pour les dommages matériels et immatériels consécutifs à l'exécution de ces prestations d'ordre électrique ou consécutivement à des travaux d'ordre électrique.
                </p>
                <p style={paragraphStyle}>
                  Les produits et marchandises sont couverts par la garantie légale des vices cachés au sens de l'article 1641 du Code Civil ainsi que par la garantie constructeur propre à chacun. L'installation de matériel fourni par le client, à sa demande, engendre l'annulation des garanties de prestation (une intervention de dépannage sur lesdits matériels sera facturée comme tel). L'entreprise Ozarkselec s'octroie la possibilité de refuser l'installation desdits matériels eu égard à leur conformité et état général.
                </p>
                <p style={paragraphStyle}>
                  En cas de non-conformité, l'entreprise Ozarkselec ne sera tenue qu'au remplacement ou à la réparation des pièces ou travaux non-conformes, excluant des dommages et intérêts pour quelque cause que ce soit.
                </p>
                <p style={paragraphStyle}>
                  Toute garantie est aussi exclue en cas de mauvaise utilisation, négligence, défaut d'entretien de la part du client, usure normale du bien ou dégradation.
                </p>
                <p style={paragraphStyle}>
                  Toute modification, ajout, suppression ou intervention effectuée par un tiers, sans autorisation écrite d'Ozarkselec, entraînera l'annulation des garanties contractuelle, décennale ou multirisque professionnel pour les éléments, circuits ou structures modifiés.
                </p>
              </div>

              {/* Article 13 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 13 : ATTRIBUTION DE COMPÉTENCES</h2>
                <p style={paragraphStyle}>
                  Pour toutes contestations relatives aux ventes réalisées par l'entreprise Ozarkselec et à l'application ou à l'interprétation des présentes Conditions Générales de vente, seul sera responsable le Tribunal de DOUAI (59).
                </p>
              </div>

              {/* Article 14 */}
              <div style={sectionStyle}>
                <h2 style={articleTitleStyle}>ARTICLE 14 : DROIT À L'IMAGE</h2>
                <p style={paragraphStyle}>
                  Le client autorise l'entreprise Ozarkselec à procéder à des prises de vues de l'intervention à l'intérieur comme à l'extérieur du bâtiment, à des fins publicitaires. L'entreprise Ozarkselec garantit ne donner aucune information sur ses clients.
                </p>
                <p style={paragraphStyle}>
                  Le client autorise l'entreprise Ozarkselec à mettre en place un panneau, banderole ou signalétique publicitaire sur la façade des bâtiments ou sur les portails de façon visible et de la manière la plus adapté pour une durée prolongée.
                </p>
              </div>

              {/* Date de mise à jour */}
              <div style={{
                marginTop: '40px',
                paddingTop: '20px',
                borderTop: '1px solid #e0e0e0',
                textAlign: 'right',
              }}>
                <p style={{ color: 'var(--ozarks-gray)', fontSize: '13px', margin: 0, fontStyle: 'italic' }}>
                  Dernière mise à jour : 17/03/26
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CGV;
